// extracted by mini-css-extract-plugin
export default {"searchArea":"Products_searchArea__EX4FH","search":"Products_search__bQBpa","select":"Products_select__6Dtqc"};